import React, { useState } from "react";
import { Table, TableBody, TableContainer, TableHead, TableRow, Paper, Typography } from "@material-ui/core";
import {AiFillFilePdf} from 'react-icons/ai'
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from '@mui/material/styles';
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";


const rows = [
  { slNo: 1, isUrl: false,  description: "Seniority List of Gazetted Officials", pdfUrl: "f9d77f7c-bbe0-402a-89ef-2dcebe18a221" },
  { slNo: 2, isUrl: true, description: "Seniority List of Non Gazetted Official", pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Seniority_list_of_Non_Gazetted_Official_.pdf" },
  { slNo: 3, isUrl: false, description: "DETAILS OF SANCTIONED/FILLED/VACANT POSTS IN TOWN & COUNTRY PLANNING DEPARTMENT AS ON 31.03.2019", pdfUrl: "cc5544b7-c6df-4630-aa16-46c42dd028b7" },
  { slNo: 4, isUrl: false, description: "R & P Rules for Surveyor Class-III", pdfUrl: "a7cfddee-dd7c-4ea5-b9e5-aef1ce11b651" },
  { slNo: 5, isUrl: false, description: "R & P Rules for Sr. Planning Draughtman Class-II", pdfUrl: "94c1dac7-714d-4b70-bcb9-a0762d7e2bcd" },
  { slNo: 6, isUrl: false, description: " R & P Rules for Research Asstt. Class-III", pdfUrl: "5fc5a456-bfa0-40b2-a05f-7d1204297ae8" },
  { slNo: 7, isUrl: false, description: " R & P Rules for Research Officer Class-II", pdfUrl: "ef7057f8-9a32-418e-a840-7805e73c194d"},
  { slNo: 8, isUrl: true, description: "R & P Rules for Planning Officer Class-I", pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/P.O_Rules_2.pdf" },
  { slNo: 9,isUrl: false, description: "R & P Rules for Jr. Engg. Class-III", pdfUrl: "37dff1f0-1dc1-4813-8977-f792a3b8c7df" },
  { slNo: 10,isUrl: false, description: "R & P Rules for Jr. Engg. Class-III", pdfUrl: "6049567a-89c5-45c5-970c-9b3677aae112" },
  { slNo: 11,isUrl: false, description: "R & P Rules for Jr. Draughtsman Class-III", pdfUrl: "1eebc371-c030-4392-b1fa-643e92060d08" },
  { slNo: 12,isUrl: false, description: "R & P Rules for Ferro Printer Class-III Part-II", pdfUrl: "8eb92d88-a2af-4b00-9c09-bf3746b34339" },
  { slNo: 13,isUrl: false, description: "R & P Rules for Ferro Printer Class-III", pdfUrl: "d01b4b89-ebd7-4a70-a067-c187d53e2c96" },
  { slNo: 14,isUrl: false, description: "R & P Rules for Draughtman Class-III", pdfUrl: "fc8f2b4e-ee8b-4251-8933-e65b81bfd2fb" },
  { slNo: 15,isUrl: false, description: "R & P Rules for Assistant Town Planner Class-I", pdfUrl: "9d9a0b04-c3ed-467d-bc47-8170ea5a80a8" },
  { slNo: 16,isUrl: false, description: "R & P Rules for Field Investigator Class-III Part-II", pdfUrl: "4c7fc858-60de-4090-a05c-f17b5db232b5" },
  { slNo: 17,isUrl: false, description: "R & P Rules for Field Investigator Class-III", pdfUrl: "774a10f4-1cc0-41c3-98c4-3f8c81d4d26e" },
  { slNo: 18,isUrl: false, description: " R & P Rules of Peon", pdfUrl: "da6138d9-6e44-4c00-9fd2-a104dc8286af" },
  { slNo: 19,isUrl: false, description: " R & P Rules of Chainman", pdfUrl: "8e0dc69d-fe97-4840-9369-7908dd18156d"},
  { slNo: 20,isUrl: false, description: " Rules for Regulating the Payment for the Grant-in-Aid", pdfUrl: "6c0cb9d4-b0d5-4df3-99e2-432fc6ec9228" },
  { slNo: 21,isUrl: false, description: " R & P Rules of Officers", pdfUrl: "0e8d8e70-d49b-4e62-9a8e-639ad6435a28" },
  { slNo: 22,isUrl: false, description: "Job Profile", pdfUrl: "016c3651-2f1e-4c84-9016-9f3f304fe720" },
  { slNo: 23,isUrl: false, description: "Syallbus for Driver", pdfUrl: "d441a723-c7ed-4960-94f6-a706a6c584c5" },

];
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#1f4a7c",
    color: theme.palette.common.white,
    fontSize: 16
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const handlePdfDownload = (pdfUrl) => {
  window.open(pdfUrl);
};

const ServiceMatter = () => {
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  return (
    <React.Fragment>
    <TableContainer component={Paper}>
    <Typography variant='h6' style={{margin: '20px'}}>
      Service Matter
    </Typography>
      <Table aria-label="Sample Table" style={{width: '90%', margin: '30px'}}>
        <TableHead>
          <StyledTableRow style={{background: '#1F4A7C', height: '20px', color: 'white'}}>
            <TableCell style={{width: '5%', border: '1px solid #ffff'}}>SL. No</TableCell>
            <TableCell style={{ border: '1px solid #ffff'}}>Headline</TableCell>
            <TableCell style={{ border: '1px solid #ffff'}}>Download</TableCell>
          </StyledTableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <StyledTableRow key={row.slNo}>
              <StyledTableCell component="th" scope="row">
                {row.slNo}
              </StyledTableCell>
              <StyledTableCell>{row.description}</StyledTableCell>
              <StyledTableCell onClick={() => row?.isUrl ? handlePdfDownload(row.pdfUrl) :  getDocumentByFileStoreId(row.pdfUrl, setIsPreviewLoading)}><AiFillFilePdf style={{width: '30px', height: '30px',  color:'#f44b55', cursor: 'pointer' }}/></StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </React.Fragment>
  );
};

export default ServiceMatter;
